import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-[#121212] text-white py-20 px-4">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-4xl font-black mb-8 border-b border-orange-500 pb-4 uppercase">
          Termos de Uso
        </h1>
        <div className="space-y-6 text-gray-300 leading-relaxed text-justify">
          <p>Seja bem-vindo ao UNIFICADOS. Ao acessar este site, você concorda com os seguintes termos...</p>
          <h2 className="text-xl font-bold text-orange-500">1. Uso do Conteúdo</h2>
          <p>Todo o material aqui contido é para fins informativos e de engajamento da nossa comunidade.</p>
          {/* Adicione o restante do seu texto aqui */}
        </div>
      </div>
    </div>
  );
};

export default Terms;